import React, { useState } from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import colors from 'src/utils/colors';
import { ActionPill } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/Settings/components/StyledPill';

export interface KeywordsListProps {
  variant: 'inclusion' | 'exclusion';
  keywords: string[];
}

export const KeywordsList: React.FC<KeywordsListProps> = ({ variant, keywords }) => {
  const [showAll, setShowAll] = useState(false);

  const hasMoreThanTen = keywords.length > 10;
  const displayed = showAll ? keywords : keywords.slice(0, 10);

  return (
    <Flex flexDirection="column" gap={16}>
      <Flex
        sx={{
          flexWrap: 'wrap',
          gap: '8px'
        }}
      >
        {displayed.map((keyword) => (
          <ActionPill
            key={keyword}
            variant="filled"
            pillSx={{
              height: '26px',
              padding: '4px 8px',
              fontSize: '12px',
              whiteSpace: 'nowrap',
              fontWeight: 500,
              boxSizing: 'border-box',
              ...(variant === 'exclusion' && {
                backgroundColor: colors.opaqueGrey,
                color: colors.graysSecondaryText
              })
            }}
            iconSx={{ display: 'none' }}
          >
            {keyword}
          </ActionPill>
        ))}
      </Flex>
      {hasMoreThanTen && (
        <Text
          variant="body3"
          sx={{ cursor: 'pointer', textDecoration: 'underline', fontWeight: 500 }}
          onClick={() => setShowAll((v) => !v)}
        >
          {showAll ? 'Show less' : 'Show more'}
        </Text>
      )}
    </Flex>
  );
};

export default KeywordsList;
